import classNames from "classnames";
import { HeadFC, navigate, PageProps } from "gatsby";
import React from "react";
import { DashedText } from "../elements/DashedText";
import Layout from "../layouts/Layout";
import { SectionPaddingClassName } from "../styles";

const Page404: React.FC<PageProps> = ({ location: { pathname } }) => {
  return (
    <Layout corePath={pathname}>
      <section
        data-component="404"
        className={classNames(
          "page-grid relative h-screen bg-hyacinth",
          SectionPaddingClassName,
        )}
      >
        <h2 className="h3 col-span-4 col-start-2 text-lazer lg:col-span-4 lg:col-start-4">
          error 404
        </h2>
        <h1 className="h1 col-span-4 col-start-2 text-cotton lg:col-span-9 lg:col-start-4">
          We could not find the page you are looking for.
        </h1>
        <button
          className="h3 col-span-3 col-start-3 flex text-lazer lg:col-span-5 lg:col-start-9"
          onClick={() => {
            void navigate(-1);
          }}
        >
          <DashedText>Please go back</DashedText>
        </button>
      </section>
    </Layout>
  );
};

// eslint-disable-next-line import/no-unused-modules
export default Page404;

// eslint-disable-next-line import/no-unused-modules
export const Head: HeadFC = () => (
  <>
    <title>Not found</title>
    <meta name="designer" content="Bond London" />
  </>
);
